import React from 'react'
import { Row } from '@headtrip/components-react'
import CategoryListItem from './CategoryListItem'
import { Category } from '../../types/tree'

interface CategoryListProps {
  categories: Category[]
  productSlug: string
}

const CategoryList = (props: CategoryListProps) => {
  const {
    categories,
    productSlug
  } = props

  return (
    <Row>
      {
        categories.map((category, index) => {
          return (
            <CategoryListItem
              key={`cat-list-item-${index}`}
              category={category}
              productSlug={productSlug}
            />
          )
        })
      }
    </Row>
  )
}

export default CategoryList
